/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { Icon } from 'react-inv-forms';
import EditableCell from '../EditableCell';
import TableActionButtons from '../TableActionButtons';
import addRed from '../../../../images/addRed.svg';
import { CustomTable, FabButton, Label } from '../../../../styles/sharedUIElemStyles';
import { selectRealizatorzy, openRealizatorzyModal, closeRealizatorzyModal } from '../../../../redux/appConfig/actions';
import { realizatorzyColumns } from '../../../../settings/tableColumns';
import RealizatorzyListModal from '../RealizatorzyListModal';
import DataDestructuring from '../../../../helpers/DataDestructuring';
import { RootState } from '../../../../redux/reducers';
import { useTranslation } from 'react-i18next';

const { addKey, createReadOnlyColumns } = DataDestructuring;

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

interface Props extends MapStateToProps, MapDispatchToProps {
  value: Form.RealizatorsFormValue;
  defaultValue: Form.RealizatorsFormValue;
  updateFormData: (data: any) => void;
  index: string;
  readOnly: boolean;
  template: any;
}
/**
 * Komponent tabeli Realizatorzy przedmiotu
 *
 */
const RealizatorzyTable = (props: Props): React.ReactElement => {
  const { t } = useTranslation();
  const [alreadySelected, setAlreadySelected] = useState(props.value.data.map(instructor => instructor.prowadzacyPId));
  const deleteRecord = (id: string): void => {
    const dataWithKey = addKey(props.value.data, 'prowadzacyPId');
    const filteredData = dataWithKey.filter(item => item.key !== id);
    const updatedValue = {
      ...props.value,
      data: filteredData,
    };
    props.updateFormData(updatedValue);
    setAlreadySelected(filteredData.map(instructor => instructor.prowadzacyPId));
  };
  const addInstructors = (instructors: any[]): void => {
    const updatedInstructors = [...props.value.data, ...instructors];
    const updatedData = {
      ...props.value,
      data: updatedInstructors,
    };
    props.updateFormData(updatedData);
    setAlreadySelected(updatedInstructors.map(instructor => instructor.prowadzacyPId));
    props.closeRealizatorzyModal();
  };
  const openInstructorsModal = (): void => {
    props.openRealizatorzyModal();
  };
  const dataWithKey = addKey(props.value.data, 'prowadzacyPId');
  const defaultDataWithKey = addKey(props.defaultValue.data, 'prowadzacyPId');
  const actionColumns: SingleColumn[] = [...realizatorzyColumns];
  actionColumns.push({
    title: '',
    dataIndex: 'actions',
    width: '10%',
    sorter: false,
    // eslint-disable-next-line react/display-name
    render: (_: any, record: any): React.ReactElement => {
      return <TableActionButtons editable={false} disabled={false} onDelete={deleteRecord.bind(null, record.key)} />;
    },
  });

  const mergedColumns = actionColumns.map((col: SingleColumn) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: SingleColumn): SingleColumn => ({
        record,
        inputType: col.type,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: false,
        sorter: false,
      }),
    };
  });
  return (
    <>
      {props.readOnly ? null : <Label>{t('BEFORE_CHANGE')}</Label>}
      <CustomTable
        dataSource={props.readOnly ? dataWithKey : defaultDataWithKey}
        columns={!props.readOnly ? createReadOnlyColumns(realizatorzyColumns) : realizatorzyColumns}
        rowClassName='editable-row'
        pagination={false}
        locale={{ emptyText: t('NO_DATA') }}
        className={!props.readOnly ? 'table__readOnly' : ''}
      />
      {!props.readOnly ? (
        <Form component={false}>
          <CustomTable
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={dataWithKey}
            columns={mergedColumns}
            rowClassName='editable-row'
            pagination={false}
            locale={{ emptyText: t('NO_DATA') }}
          />
          <FabButton onClick={openInstructorsModal} data-cy='btnSubjectCardAddRealizer'>
            <Icon path={addRed} />
          </FabButton>
        </Form>
      ) : null}
      {props.realizatorzyListModal.opened ? (
        <RealizatorzyListModal
          alreadySelected={alreadySelected}
          onAddRealizatorzy={addInstructors}
          onClose={props.closeRealizatorzyModal}
          onSelectRealizator={props.selectRealizatorzy}
          realizatorzyListModal={props.realizatorzyListModal}
        />
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  realizatorzyListModal: state.AppConfig.realizatorzyListModal,
});

const mapDispatchToProps = (dispatch: any) => ({
  openRealizatorzyModal: () => dispatch(openRealizatorzyModal()),
  closeRealizatorzyModal: () => dispatch(closeRealizatorzyModal()),
  selectRealizatorzy: (data: number[]) => dispatch(selectRealizatorzy(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RealizatorzyTable);
